import { render } from "./TopicSetView.vue?vue&type=template&id=a300b132&scoped=true"
import script from "./TopicSetView.vue?vue&type=script&lang=js"
export * from "./TopicSetView.vue?vue&type=script&lang=js"

import "./TopicSetView.vue?vue&type=style&index=0&id=a300b132&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a300b132"]])

export default __exports__